import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Logger, throwInternalError } from '@prodcard/core'
import { onUnmounted } from 'vue'
import { onMounted } from 'vue'
import { ref } from 'vue'

const vertexShader = `#version 300 es
precision highp float;
in vec2 inPos;
out vec2 inFragCoord;
void main()
{
  gl_Position = vec4(inPos, 0.0, 1.0);
  inFragCoord = inPos;
}
`


export default /*#__PURE__*/_defineComponent({
  __name: 'ShaderBackground',
  props: {
    source: {},
    timeScale: {}
  },
  setup(__props: any) {

const props = __props;

const logger = new Logger('ShaderBackground')



let stopAnimation = false

const fragmentShader = `#version 300 es
precision highp float; uniform vec2 iResolution; uniform vec2 iMouse; uniform float iTime; 
in vec2 inFragCoord;
out vec4 outFragColor;

${props.source}

void main() 
{
  mainImage( outFragColor, inFragCoord );
}
`

function loadShader(gl: WebGL2RenderingContext, prog: WebGLProgram, type: number, source: string) {
  const shaderObj = gl.createShader(type) ?? throwInternalError('<2873c9dd>')
  gl.shaderSource(shaderObj, source)
  gl.compileShader(shaderObj)
  const status = gl.getShaderParameter(shaderObj, gl.COMPILE_STATUS)
  if (!status) throwInternalError(`<001441bb> Cannot compile shader ${status}: ${gl.getShaderInfoLog(shaderObj)}`)
  gl.attachShader(prog, shaderObj)
}

function setupCanvas(canvas: HTMLCanvasElement): boolean {
  try {
    const gl = canvas.getContext('webgl2') ?? throwInternalError('<4734400f> Cannot initialize WebGL2')
    const prog = gl.createProgram() ?? throwInternalError('<dc27e916> Create program')
    loadShader(gl, prog, gl.VERTEX_SHADER, vertexShader)
    loadShader(gl, prog, gl.FRAGMENT_SHADER, fragmentShader)
    gl.linkProgram(prog)
    const linkStatus = gl.getProgramParameter(prog, gl.LINK_STATUS)
    if (!linkStatus) throwInternalError(`<b2c1d30d> Cannot link program: ${gl.getProgramInfoLog(prog)}`)

    const uniformVars = {
      inPos: gl.getAttribLocation(prog, 'inPos'),
      iTime: gl.getUniformLocation(prog, 'iTime'),
      iMouse: gl.getUniformLocation(prog, 'iMouse'),
      iResolution: gl.getUniformLocation(prog, 'iResolution'),
    }

    gl.useProgram(prog)

    const pos = [-1, -1, 1, -1, 1, 1, -1, 1]
    const inx = [0, 1, 2, 0, 2, 3]
    const posBuffer = gl.createBuffer() ?? throwInternalError('<f801d82f>')
    gl.bindBuffer(gl.ARRAY_BUFFER, posBuffer)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(pos), gl.STATIC_DRAW)
    const inxBuf = gl.createBuffer()
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, inxBuf)
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(inx), gl.STATIC_DRAW)
    gl.enableVertexAttribArray(uniformVars.inPos)
    gl.vertexAttribPointer(uniformVars.inPos, 2, gl.FLOAT, false, 0, 0)

    gl.enable(gl.DEPTH_TEST)
    gl.clearColor(0.0, 0.0, 0.0, 1.0)
    window.onresize = resize
    resize()

    function resize() {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }

    function render(time: number) {
      if (stopAnimation) return
      gl.viewport(0, 0, canvas.width, canvas.height)
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)

      gl.uniform1f(uniformVars.iTime, (time / 1000.0) * (props.timeScale ?? 1.0))
      gl.uniform2f(uniformVars.iResolution, canvas.width, canvas.height)
      gl.uniform2f(uniformVars.iMouse, 0, 0)
      gl.drawElements(gl.TRIANGLES, inx.length, gl.UNSIGNED_SHORT, 0)

      requestAnimationFrame(render)
    }

    requestAnimationFrame(render)

    return true
  } catch (e) {
    logger.error({}, e instanceof Error ? e.message : `<11fcf138> Unknown error: ${e}`)
    return false
  }
}

const canvasRef = ref()
onMounted(() => {
  setupCanvas(canvasRef.value)
})

onUnmounted(() => {
  stopAnimation = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    style: {"background-color":"black"},
    ref_key: "canvasRef",
    ref: canvasRef,
    width: "1024",
    height: "768"
  }, null, 512))
}
}

})